import * as React from 'react';

interface DriverJobsSiteDeparturePlanChangesProps {
    planChanges: PlanChanges;
    isPickup: boolean;  //true if all jobs are pickups
    errors: any;
    update(planChanges: PlanChanges, fieldName: string): void;
}

interface DriverJobsSiteDeparturePlanChanges {
    loading: boolean;
}

interface PlanChanges {
    planChanges: number;
    plan: File,
    planComments: string;
    notes: string;
}

export default class DriverJobsSiteDeparturePlanChangesData extends React.Component<DriverJobsSiteDeparturePlanChangesProps, DriverJobsSiteDeparturePlanChanges> {
    constructor(props: DriverJobsSiteDeparturePlanChangesProps) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange = (e: any) => {
        var completeJob = this.props.planChanges;
        let change: any = {};
        change = completeJob;
        change[e.target.name] = e.target.value * 1;
        this.props.update(completeJob, e.target.name);
    }

    handleChangeText = (e: any) => {
        var completeJob = this.props.planChanges;
        let change: any = {};
        change = completeJob;
        change[e.target.name] = e.target.value;
        this.props.update(completeJob, e.target.name);
    }

    uploadplan = (e: any) => {
        var completeJob = this.props.planChanges;
        completeJob.plan = e.target.files[0];
        this.props.update(completeJob, e.target.name);
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let completeJob = this.props.planChanges;
        let planChanges = completeJob.planChanges * 1;

        return (
            <div>
                <div className={this.props.isPickup ? "hidden" : ""}>
                    <label className="input-group alignitemscentre" htmlFor="planChanges">
                        <span className="label-mobile--inline margin5">Are there any plan changes?</span>
                        <input type="radio" className="marginRight10" id="yes" name="planChanges" value={1} checked={completeJob.planChanges === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginRight10">Yes</span>
                        <input type="radio" className="marginRight10" id="no" name="planChanges" value={0} checked={completeJob.planChanges === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical">No</span>
                    </label>
                    <span className="label errors">{this.props.errors["planChanges"]}</span>
                </div>
                <div className={planChanges === 0 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="notes">
                        <span className="label-mobile">Additional Notes - optional</span>
                        <textarea className="input job__noteSize label-mobile" maxLength={500} id="notes" name="notes" value={completeJob.notes} onChange={(e) => this.handleChangeText(e)}></textarea>
                    </label>
                </div>
                <div className={planChanges === 1 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="file">
                        <span className="label-mobile--inline margin5">Upload Photo of Plan</span>
                        <input type="file" id="file" name="file" accept="image/*" onChange={this.uploadplan} />
                    </label>
                    <span className="label errors">{this.props.errors["plan"]}</span>
                    <label className="input-group" htmlFor="planComments">
                        <span className="label-mobile--inline margin5">Comments</span>
                        <textarea className="input notes__planChanges" maxLength={500} id="planComments" name="planComments" value={completeJob.planComments} onChange={(e) => this.handleChangeText(e)}></textarea>
                    </label>
                    <span className="label errors">{this.props.errors["planComments"]}</span>
                </div>
            </div>
        );

    }
}
